import * as utils from './Utils';



function deserializeProductPrice(product, variant, data) {
  let calculatedPrice = data.calculatedCheapestPrice;

  if (product && !variant) {
    product.setPrice(calculatedPrice.unitPrice);
    product.setCompareAtPrice(calculatedPrice.listPrice && calculatedPrice.listPrice.price ? calculatedPrice.listPrice.price : 0);
    product.setDiscountAmount(product.compareAtPrice > product.price ? product.compareAtPrice - product.price : 0);
    product.setCurrency(window.OnVoardData.active_currency);
  }

  if (product && variant) {
    variant.setPrice(calculatedPrice.unitPrice);
    variant.setCompareAtPrice(calculatedPrice.listPrice && calculatedPrice.listPrice.price ? calculatedPrice.listPrice.price : 0);
    product.setCurrency(window.OnVoardData.active_currency);
  }
}


export function fetchProductPrices(products, callback) {
  let productIds = [];

  products.forEach((product) => {
    productIds.push(product.externalId);

    if (product.variants && product.variants.length > 0) {
      product.variants.forEach((variant) => {
        productIds.push(variant.id);
      })
    }
  })

  fetch(window.OnVoardData["sw_storefront_url"] + '/store-api/product', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'sw-access-key': window.OnVoardData["sw_access_key"],
      'sw-context-token': window.OnVoardData["sw_context_token"]
    },
    body: JSON.stringify({
      "ids": productIds,
      "includes": {
        "product": [
          "id", "parentId", "productNumber", "calculatedCheapestPrice"
        ]
      }
    })
  })
  .then(res => res.json())
  .then(json => {
    json.elements.forEach((row) => {
      let matchedProduct = null;
      let matchedVariant = null;

      products.forEach((product) => {
        if (matchedProduct || matchedVariant) return;
        if (product.externalId === row.id) {
          matchedProduct = product;
          return;
        }

        if (product.variants && product.variants.length > 0) {
          product.variants.forEach((variant) => {
            if (matchedVariant) return;
            if (variant.id === row.id) {
              matchedProduct = product;
              matchedVariant = variant;
              return;
            }
          })
        }
      })

      if (!matchedProduct && !matchedVariant) return;
      deserializeProductPrice(matchedProduct, matchedVariant, row);
    })

    callback(json);
  })
  .catch(error => {
    console.error(error);
    callback(error);
  })
}
